import script from "./examTest.vue?vue&type=script&lang=ts&setup=true"
export * from "./examTest.vue?vue&type=script&lang=ts&setup=true"

import "./examTest.vue?vue&type=style&index=0&id=59eda2ab&lang=less&scoped=true"

import exportComponent from "D:\\officialWebsite\\web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59eda2ab"]])

export default __exports__